import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  createCertificateRequest,
  getCertificates,
  removeCertificate,
  updateCertificateRequest,
} from "../../../../services/api/landing/companyCertificates/companyCertificatesApi";

const getLang = () =>
  localStorage.getItem("language") === "ar" ? "ar" : "en";

const toastMessages = {
  add: {
    en: "Certificate created successfully!",
    ar: "تم إنشاء الشهادة بنجاح!",
  },
  addError: {
    en: "Failed to create certificate.",
    ar: "فشل في إنشاء الشهادة.",
  },
  update: {
    en: "Certificate updated successfully!",
    ar: "تم تحديث الشهادة بنجاح!",
  },
  updateError: {
    en: "Failed to update certificate.",
    ar: "فشل في تحديث الشهادة.",
  },
  delete: {
    en: "Certificate deleted successfully!",
    ar: "تم حذف الشهادة بنجاح!",
  },
  deleteError: {
    en: "Failed to delete certificate.",
    ar: "فشل في حذف الشهادة.",
  },
};

export const fetchCertificates = createAsyncThunk(
  "certificates/fetchCertificates",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCertificates();
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch certificates");
    }
  },
);

export const createCertificate = createAsyncThunk(
  "certificates/createCertificate",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createCertificateRequest(formData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to create certificate");
    }
  },
);

export const updateCertificate = createAsyncThunk(
  "certificates/updateCertificate",
  async ({ certificateId, formData }, { rejectWithValue }) => {
    try {
      const response = await updateCertificateRequest(certificateId, formData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to update certificate");
    }
  },
);

export const deleteCertificate = createAsyncThunk(
  "certificates/deleteCertificate",
  async (certificateId, { rejectWithValue }) => {
    try {
      await removeCertificate(certificateId);
      return certificateId;
    } catch (error) {
      return rejectWithValue("Failed to delete certificate");
    }
  },
);

const companyCertificateSlice = createSlice({
  name: "certificates",
  initialState: {
    certificateData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCertificates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCertificates.fulfilled, (state, action) => {
        state.loading = false;
        state.certificateData = action.payload;
      })
      .addCase(fetchCertificates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCertificate.fulfilled, (state, action) => {
        state.certificateData.push(action.payload);
        toast.success(toastMessages.add[getLang()]);
      })
      .addCase(createCertificate.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.addError[getLang()]);
      })
      .addCase(updateCertificate.fulfilled, (state, action) => {
        const index = state.certificateData.findIndex(
          (cert) => cert.id === action.payload.id,
        );
        if (index !== -1) {
          state.certificateData[index] = action.payload;
        }
        toast.success(toastMessages.update[getLang()]);
      })
      .addCase(updateCertificate.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.updateError[getLang()]);
      })
      .addCase(deleteCertificate.fulfilled, (state, action) => {
        state.certificateData = state.certificateData.filter(
          (cert) => cert.id !== action.payload,
        );
        toast.success(toastMessages.delete[getLang()]);
      })
      .addCase(deleteCertificate.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.deleteError[getLang()]);
      });
  },
});

export default companyCertificateSlice.reducer;
